import { ReactNode, createContext, useContext, useEffect, useState } from 'react';
import { CurrentUser, clearSession, fetchMe, logout as ssoLogout } from '../lib/auth-client';

interface AuthContextValue {
  user: CurrentUser | null;
  loading: boolean;
  setUser: (u: CurrentUser | null) => void;
  logout: () => Promise<void>;
}

const AuthContext = createContext<AuthContextValue | null>(null);

export function AuthProvider({ children }: { children: ReactNode }) {
  const [user, setUser] = useState<CurrentUser | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Startup: kiểm session (từ launcher redirect hoặc localStorage).
    // Nếu có → fetch /me → set user. Nếu không → user null → App redirect /login.
    (async () => {
      try {
        const me = await fetchMe();
        setUser(me);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const logout = async () => {
    await ssoLogout();
    clearSession();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, setUser, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth(): AuthContextValue {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth phải dùng trong AuthProvider');
  return ctx;
}
